import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import { A } from 'components/common/Link/Link'
import {
  COMPATIBILITY_STATUS_NO_COMPATIBLE_MESSAGE,
  COMPATIBILITY_STATUS_COMPATIBLE,
  COMPATIBILITY_STATUS_NON_COMPATIBLE,
  COMPATIBILITY_STATUS_SPEED_RATING_NOT_MATCHED,
  COMPATIBILITY_STATUS_SIZE_NOT_MATCH,
  COMPATIBILITY_STATUS_NO_VEHICLE
} from 'constant'

const NoCompatibleMessage = () => null

const Compatible = ({ vehicle, dense }) =>
  <Compatibility dense={ dense }>
    <TitleCompatible>
      <Check asset="check-circle" margin="0 10px 0 0" />
      COMPATIBLE
    </TitleCompatible> with your { vehicle }
  </Compatibility>

Compatible.propTypes = {
  dense: PropTypes.bool,
  vehicle: PropTypes.string
}

const NonCompatible = ({ vehicle, dense }) =>
  <Compatibility dense={ dense }>
    <TitleNonCompatible>
      <Check asset="denied" margin="0 10px 0 0" />
      Load Range/Index does not meet requirements for
    </TitleNonCompatible> a { vehicle }
  </Compatibility>

NonCompatible.propTypes = {
  dense: PropTypes.bool,
  vehicle: PropTypes.string
}

const SpeedRatingNotMatched = ({ vehicle, dense }) =>
  <Compatibility dense={ dense }>
    <TitleWarning>Does not meet speed rating for a</TitleWarning> { vehicle }
  </Compatibility>

SpeedRatingNotMatched.propTypes = {
  dense: PropTypes.bool,
  vehicle: PropTypes.string
}

const SizeNotMatched = ({ vehicle, dense }) =>
  <Compatibility dense={ dense }>
    <TitleWarning>Does not match the configured size on</TitleWarning> { vehicle }
  </Compatibility>

SizeNotMatched.propTypes = {
  dense: PropTypes.bool,
  vehicle: PropTypes.string
}

const NoVehicle = ({ vehicle, dense, addVehicle }) =>
  <Compatibility dense={ dense }>
    No Vehicle Associated with this tire |&nbsp;
    <StyledA data-at-select-vehicle prevent underline handler={ addVehicle }>Select vehicle</StyledA>
  </Compatibility>

NoVehicle.propTypes = {
  addVehicle: PropTypes.func,
  dense: PropTypes.bool,
  vehicle: PropTypes.string
}

const statuses = {
  [COMPATIBILITY_STATUS_NO_COMPATIBLE_MESSAGE]: NoCompatibleMessage,
  [COMPATIBILITY_STATUS_COMPATIBLE]: Compatible,
  [COMPATIBILITY_STATUS_NON_COMPATIBLE]: NonCompatible,
  [COMPATIBILITY_STATUS_SPEED_RATING_NOT_MATCHED]: SpeedRatingNotMatched,
  [COMPATIBILITY_STATUS_SIZE_NOT_MATCH]: SizeNotMatched,
  [COMPATIBILITY_STATUS_NO_VEHICLE]: NoVehicle
}

const CompatibilityLabel = ({ status, ...props }) => {
  const Component = statuses[status] || NonCompatible
  return <Component { ...props } />
}

CompatibilityLabel.propTypes = {
  status: PropTypes.string
}

export default CompatibilityLabel

const TitleCompatible = styled.span`
  text-transform: uppercase;
  color: ${Theme.colors.green};
  font-weight: bold;
`

const TitleNonCompatible = styled.span`
  color: ${Theme.colors.bright_red_new};
  font-weight: bold;
`

const TitleWarning = styled.span`
  color: ${Theme.colors.orange};
  font-weight: bold;
`

const Check = styled(Icon)`
  width: 15px;
  margin-right: 5px;
  margin-top: -2px;
`

const Compatibility = styled.div.attrs({
  'data-at-compatibilitylabel': true
})`
  line-height: 22px;
  font-size: 12px;
  margin-bottom: ${props => props.dense ? '5px' : '15px'};
`

const StyledA = styled(A)`
  font-size: 12px;
`
